import { useEffect, useRef, useState } from "react";
import { ModalBackdrop } from "./ModalBackdrop";
import { IcoClose, IcoEdit } from "./icons";

interface RenameDialogProps {
  title?: string;
  label?: string;
  initialValue: string;
  placeholder?: string;
  busy?: boolean;
  onSave: (value: string) => void;
  onClose: () => void;
}

export function RenameDialog({
  title = "Переименовать",
  label,
  initialValue,
  placeholder,
  busy,
  onSave,
  onClose,
}: RenameDialogProps) {
  const [value, setValue] = useState(initialValue);
  const inputRef = useRef<HTMLInputElement | null>(null);

  useEffect(() => {
    const el = inputRef.current;
    if (!el) return;
    el.focus();
    el.select();
  }, []);

  const trimmed = value.trim();
  const canSave = trimmed.length > 0 && trimmed !== initialValue.trim() && !busy;

  const save = () => {
    if (!canSave) return;
    onSave(trimmed);
  };

  return (
    <ModalBackdrop onClose={onClose}>
      <div className="modal modal-narrow" onClick={(e) => e.stopPropagation()} role="dialog">
        <div className="modal-head">
          <div className="launch-dot" style={{ background: "var(--accent-soft)" }}>
            <IcoEdit size={12} stroke="var(--accent)" />
          </div>
          <h2>{title}</h2>
          <div className="spacer" />
          <button
            type="button"
            className="modal-close"
            onClick={onClose}
            disabled={busy}
            aria-label="Закрыть"
          >
            <IcoClose size={16} />
          </button>
        </div>
        <div className="modal-body">
          {label && (
            <label
              style={{
                display: "block",
                margin: "0 0 6px",
                fontSize: 12,
                color: "var(--text-3)",
              }}
            >
              {label}
            </label>
          )}
          <input
            ref={inputRef}
            className="form-input"
            value={value}
            placeholder={placeholder}
            disabled={busy}
            onChange={(e) => setValue(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                save();
              }
            }}
          />
        </div>
        <div className="modal-foot">
          <div className="spacer" />
          <button type="button" className="btn-ghost" onClick={onClose} disabled={busy}>
            Отмена
          </button>
          <button type="button" className="btn-primary" onClick={save} disabled={!canSave}>
            {busy ? "Сохраняем…" : "Сохранить"}
          </button>
        </div>
      </div>
    </ModalBackdrop>
  );
}
